import React from 'react';
import { Globe, AlertCircle, Link2, Copy } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const SiteHealthMetrics = ({ data }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 60) return 'text-orange-600';
    return 'text-red-600';
  };

  const getScoreBgColor = (score) => {
    if (score >= 80) return 'bg-green-50 border-green-200';
    if (score >= 60) return 'bg-orange-50 border-orange-200';
    return 'bg-red-50 border-red-200';
  };

  const metrics = [
    { label: 'Pages indexées', value: data?.indexedPages, icon: Globe, color: 'blue' },
    { label: 'Erreurs de crawl', value: data?.crawlErrors, icon: AlertCircle, color: 'red' },
    { label: 'Liens cassés', value: data?.brokenLinks, icon: Link2, color: 'orange' },
    { label: 'Contenu dupliqué', value: data?.duplicateContent, icon: Copy, color: 'yellow' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-6 flex items-center gap-2">
        <Globe className="text-green-600" size={24} />
        Santé du Site
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        {/* Overall Score */}
        <div className={`col-span-1 flex flex-col items-center justify-center p-6 rounded-lg border-2 ${getScoreBgColor(data?.overallScore)}`}>
          <div className="text-center">
            <p className="text-sm text-gray-600 mb-2">Score Global</p>
            <p className={`text-5xl font-bold ${getScoreColor(data?.overallScore)}`}>
              {data?.overallScore}
            </p>
            <p className="text-xs text-gray-500 mt-1">/100</p>
          </div>
        </div>

        {/* Metrics Grid */}
        <div className="col-span-1 md:col-span-4 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {metrics?.map((metric, index) => {
            const Icon = metric?.icon;
            const colorClasses = {
              blue: 'bg-blue-50 text-blue-600 border-blue-200',
              red: 'bg-red-50 text-red-600 border-red-200',
              orange: 'bg-orange-50 text-orange-600 border-orange-200',
              yellow: 'bg-yellow-50 text-yellow-600 border-yellow-200'
            };

            return (
              <div key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className={`inline-flex p-2 rounded-lg border mb-3 ${colorClasses?.[metric?.color]}`}>
                  <Icon size={20} />
                </div>
                <p className="text-2xl font-bold text-gray-900">{metric?.value}</p>
                <p className="text-sm text-gray-600 mt-1">{metric?.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SiteHealthMetrics;